import {NgModule} from '@angular/core';

import {TaskStatisticsComponent} from './components/task-statistics/task-statistics.component';
import {TaskOverviewComponent} from './containers/task-overview/task-overview.component';
import {CoreModule} from '../../../core';

@NgModule({
	imports: [CoreModule],
	declarations: [TaskOverviewComponent, TaskStatisticsComponent],
	providers: [],
	exports: [TaskOverviewComponent]
})
export class TaskOverviewModule {}
